var map = {
	"./Spin360_TorreOvaloC_001.jpg": 3483,
	"./Spin360_TorreOvaloC_002.jpg": 59581,
	"./Spin360_TorreOvaloC_003.jpg": 89465,
	"./Spin360_TorreOvaloC_004.jpg": 76376,
	"./Spin360_TorreOvaloC_005.jpg": 88462,
	"./Spin360_TorreOvaloC_006.jpg": 93004,
	"./Spin360_TorreOvaloC_007.jpg": 31701,
	"./Spin360_TorreOvaloC_008.jpg": 76930,
	"./Spin360_TorreOvaloC_009.jpg": 15900,
	"./Spin360_TorreOvaloC_010.jpg": 9874,
	"./Spin360_TorreOvaloC_011.jpg": 47256,
	"./Spin360_TorreOvaloC_012.jpg": 85153,
	"./Spin360_TorreOvaloC_013.jpg": 80252,
	"./Spin360_TorreOvaloC_014.jpg": 81993,
	"./Spin360_TorreOvaloC_015.jpg": 26609,
	"./Spin360_TorreOvaloC_016.jpg": 44567,
	"./Spin360_TorreOvaloC_017.jpg": 75239,
	"./Spin360_TorreOvaloC_018.jpg": 90117,
	"./Spin360_TorreOvaloC_019.jpg": 51099,
	"./Spin360_TorreOvaloC_020.jpg": 11970,
	"./Spin360_TorreOvaloC_021.jpg": 50904,
	"./Spin360_TorreOvaloC_022.jpg": 53294,
	"./Spin360_TorreOvaloC_023.jpg": 81964,
	"./Spin360_TorreOvaloC_024.jpg": 24315,
	"./Spin360_TorreOvaloC_025.jpg": 62985,
	"./Spin360_TorreOvaloC_026.jpg": 45049,
	"./Spin360_TorreOvaloC_027.jpg": 45601,
	"./Spin360_TorreOvaloC_028.jpg": 59789,
	"./Spin360_TorreOvaloC_029.jpg": 21421,
	"./Spin360_TorreOvaloC_030.jpg": 11442,
	"./Spin360_TorreOvaloC_031.jpg": 82778,
	"./Spin360_TorreOvaloC_032.jpg": 50718,
	"./Spin360_TorreOvaloC_033.jpg": 22968,
	"./Spin360_TorreOvaloC_034.jpg": 40834,
	"./Spin360_TorreOvaloC_035.jpg": 9707,
	"./Spin360_TorreOvaloC_036.jpg": 73352,
	"./Spin360_TorreOvaloC_037.jpg": 17477,
	"./Spin360_TorreOvaloC_038.jpg": 42978,
	"./Spin360_TorreOvaloC_039.jpg": 61062,
	"./Spin360_TorreOvaloC_040.jpg": 40337,
	"./Spin360_TorreOvaloC_041.jpg": 3392,
	"./Spin360_TorreOvaloC_042.jpg": 96100,
	"./Spin360_TorreOvaloC_043.jpg": 86142,
	"./Spin360_TorreOvaloC_044.jpg": 87338,
	"./Spin360_TorreOvaloC_045.jpg": 83619,
	"./Spin360_TorreOvaloC_046.jpg": 97056,
	"./Spin360_TorreOvaloC_047.jpg": 75147,
	"./Spin360_TorreOvaloC_048.jpg": 82567,
	"./Spin360_TorreOvaloC_049.jpg": 86537,
	"./Spin360_TorreOvaloC_050.jpg": 61546,
	"./Spin360_TorreOvaloC_051.jpg": 88673,
	"./Spin360_TorreOvaloC_052.jpg": 86417,
	"./Spin360_TorreOvaloC_053.jpg": 95533,
	"./Spin360_TorreOvaloC_054.jpg": 5955,
	"./Spin360_TorreOvaloC_055.jpg": 48354,
	"./Spin360_TorreOvaloC_056.jpg": 35276,
	"./Spin360_TorreOvaloC_057.jpg": 77139,
	"./Spin360_TorreOvaloC_058.jpg": 63349,
	"./Spin360_TorreOvaloC_059.jpg": 78089,
	"./Spin360_TorreOvaloC_060.jpg": 47668,
	"./Spin360_TorreOvaloC_061.jpg": 92518,
	"./Spin360_TorreOvaloC_062.jpg": 20656,
	"./Spin360_TorreOvaloC_063.jpg": 16905,
	"./Spin360_TorreOvaloC_064.jpg": 27631,
	"./Spin360_TorreOvaloC_065.jpg": 14632,
	"./Spin360_TorreOvaloC_066.jpg": 45028,
	"./Spin360_TorreOvaloC_067.jpg": 96882,
	"./Spin360_TorreOvaloC_068.jpg": 74571,
	"./Spin360_TorreOvaloC_069.jpg": 24772,
	"./Spin360_TorreOvaloC_070.jpg": 76515,
	"./Spin360_TorreOvaloC_071.jpg": 9015,
	"./Spin360_TorreOvaloC_072.jpg": 80730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53835;